import { css } from 'styled-components';
export default {
    navHeight: 107,
    navHeightTablet: 80,
    navHeightMobile: 59,
};
export const ButtonReset = css `
  border: none;
  outline: none;
  padding: 0px;
  background: none;
  border-radius: 0px;
`;
export function lineClamp(count, display = 'block') {
    const styles = css `
    display: ${display === 'block' ? 'inline-block' : 'block'};
    display: ${display === 'block' ? '-webkit-inline-box' : '-webkit-box'};
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${count};
    overflow: hidden;
  `;
    return styles;
}
